import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const paginationItems = [];

  const createPageItem = (page) => (
    <Pagination.Item
      key={page}
      active={page === currentPage}
      onClick={() => onPageChange(page)}
    >
      {page}
    </Pagination.Item>
  );

  // Helper to push ellipsis
  const addEllipsis = (key) => <Pagination.Ellipsis key={key} disabled />;

  if (totalPages <= 7) {
    // Show all pages if few enough
    for (let page = 1; page <= totalPages; page++) {
      paginationItems.push(createPageItem(page));
    }
  } else {
    // Always show first page
    paginationItems.push(createPageItem(1));

    // Show ellipsis if current page is far from the start
    if (currentPage > 4) {
      paginationItems.push(addEllipsis('start'));
    }

    // Show middle pages around current
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let page = start; page <= end; page++) {
      paginationItems.push(createPageItem(page));
    }

    // Show ellipsis if current page is far from the end
    if (currentPage < totalPages - 3) {
      paginationItems.push(addEllipsis('end'));
    }

    // Always show last page
    paginationItems.push(createPageItem(totalPages));
  }

  return (
    <Pagination className="justify-content-center mt-3">
      {paginationItems}
    </Pagination>
  );
};

export default CustomPagination;
